import { render, staticRenderFns } from "./OssMediaLink.vue?vue&type=template&id=444013a6"
import script from "./OssMediaLink.vue?vue&type=script&lang=js"
export * from "./OssMediaLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports